import Confirm from './ConfirmDialog.vue'
import type {App} from "vue"
import {createApp} from "vue"
import vuetify from "@/plugins/vuetify"

const defaultOptions: { property: string } = {
  property: '$confirm',
}

export type ConfirmOptions = {
  buttonTrueText: string
  buttonFalseText: string
  buttonTrueColor: string
  color: string
  icon: string
  message: string
  persistent: string
  showCancel: boolean
  title: string
  width: string | number
}

function createDialogCmp(options: Partial<ConfirmOptions>) {
  const container = document.querySelector('[data-app=true]') || document.body

  return new Promise(resolve => {
    const div = document.createElement('div')
    const confirmDialog = createApp(Confirm, {
      ...options,
      onClose: (value: boolean) => {
        container.removeChild(div)
        confirmDialog.unmount()
        resolve(value)
      }
    })


    confirmDialog.use(vuetify)
    confirmDialog.mount(div)
    container.appendChild(div)
  })
}

function show(message: string | undefined = undefined, title: string = 'Are you sure?', color: string = "warning", options: Partial<ConfirmOptions> = {}) {
  options.title = title
  options.message = message
  options.color = color

  return createDialogCmp(options)
}

function install(app: App, options?: typeof defaultOptions) {
  const property = options?.property || '$confirm'
  app.config.globalProperties[property] = show
}


export default install
export const $confirm = show
